if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButtons = Array.from(this.querySelectorAll('[type="submit"]'));
      if (document.querySelector('cart-drawer')) this.submitButtons.forEach(button => button.setAttribute('aria-haspopup', 'dialog'));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.handleErrorMessage();
      const submitter = evt.submitter;
      submitter.classList.add('loading');
      submitter.setAttribute('aria-disabled', true);
      submitter.querySelectorAll('.loading-overlay__spinner').forEach(loader => {
        loader.classList.remove('hidden');
      });

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (submitter.name === 'pre-order') {
        delete formData.id;
        delete formData['product-id'];
        formData.append('id', submitter.dataset.preOrderVariant);
        formData.append('product-id', submitter.dataset.preOrderProductId);
        formData.append('properties[_preOrder]', 'true');
        formData.append('properties[Pre-Order]', submitter.dataset.preOrderText);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        // Open immediately only if the cart already has items —
        // avoids briefly flashing Shopify's "cart is empty" state on first add.
        if (!this.cart.classList.contains('is-empty')) {
          this.cart.open();
        }
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.submitButtons.forEach(button => {
              const soldOutMessage = button.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              button.setAttribute('aria-disabled', true);
              button.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
            });
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              this.cart.renderContents(response);
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButtons.forEach(button => button.classList.remove('loading'));
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButtons.forEach(button => button.removeAttribute('aria-disabled'));
          this.querySelectorAll('.loading-overlay__spinner').forEach(loader => {
            loader.classList.add('hidden');
          });
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


if (!customElements.get('product-atc-sticky')) {
  class ProductAtcSticky extends HTMLElement {
    constructor() {
      super()
      this.mainButton = document.querySelector('.product-form__submit')
      this._onScroll = this.onScroll.bind(this)
      this._footerInView = false
      this._footerObserver = null
      this._mobileMql = window.matchMedia('(max-width: 767px)')
      this._onMobileChange = this.onMobileChange.bind(this)
    }

    connectedCallback() {
      this.stickyHandler()
      window.addEventListener('scroll', this._onScroll, { passive: true })
      this._mobileMql.addEventListener('change', this._onMobileChange)
      this.setupFooterObserver()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll)
      this._mobileMql.removeEventListener('change', this._onMobileChange)
      this.teardownFooterObserver()
    }

    onScroll(e) {
      this.stickyHandler()
    }

    onMobileChange() {
      this.setupFooterObserver()
      this.stickyHandler()
    }

    setupFooterObserver() {
      this.teardownFooterObserver()

      if (!this.isMobile()) {
        this._footerInView = false
        return
      }

      const footerEl =
        document.querySelector('footer.footer-custom') ||
        document.querySelector('footer') ||
        document.querySelector('#shopify-section-footer')

      if (!footerEl || !('IntersectionObserver' in window)) return

      this._footerObserver = new IntersectionObserver(
        (entries) => {
          this._footerInView = entries.some((entry) => entry.isIntersecting)
          this.stickyHandler()
        },
        { threshold: 0 }
      )

      this._footerObserver.observe(footerEl)
    }

    teardownFooterObserver() {
      if (!this._footerObserver) return
      this._footerObserver.disconnect()
      this._footerObserver = null
    }

    isMobile() {
      return this._mobileMql ? this._mobileMql.matches : window.innerWidth < 768
    }

    stickyHandler() {
      if (!this.mainButton) return

      const mainButtonTop = this.mainButton.getBoundingClientRect().top
      const shouldHideForMainButton =
        this.elementIsVisibleInViewport(this.mainButton, true) || mainButtonTop > 50
      const shouldHideForFooter = this.isMobile() && this._footerInView

      if (shouldHideForMainButton || shouldHideForFooter) {
        this.classList.add('is-hidden')
      } else {
        this.classList.remove('is-hidden')
      }
    }

    elementIsVisibleInViewport (el, partiallyVisible = false) {
      const { top, left, bottom, right } = el.getBoundingClientRect();
      const { innerHeight, innerWidth } = window;
      return partiallyVisible
        ? ((top > 0 && top < innerHeight) ||
            (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    };
  }

  customElements.define('product-atc-sticky', ProductAtcSticky)
}